import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { DespesaCadastroComponent } from './despesa-cadastro/despesa-cadastro.component';
import { DespesaFiltroComponent } from './despesa-filtro/despesa-filtro.component';
import { DespesaListaComponent } from './despesa-lista/despesa-lista.component';
import { DespesaService } from './despesa-service/despesa.service';
import { DespesaComponent } from './despesa.component';
import { FileUploadModule } from './../../../shared/fileupload/fileupload';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    FileUploadModule
  ],
  exports: [
    DespesaComponent
  ],
  declarations: [
    DespesaComponent,
    DespesaCadastroComponent,
    DespesaListaComponent,
    DespesaFiltroComponent
  ],
  providers: [
    DespesaService
  ]
})
export class DespesaModule { }
